import {IApplicationRoutes} from "./application-routes.interfaces";
import {RouteModel} from "../models/route.model";
import {IServiceFactory} from "../../service-factory.interface";
import {HomePage} from "../../../pages/home/home.page";
import React from "react";
import {SpecialPricesMarketPage} from "../../../pages/special-prices-market/special-prices-market.page";


export class ApplicationRoutes implements IApplicationRoutes {
    constructor(private readonly services: IServiceFactory) {
    }

    home = new RouteModel(['/', '/index.html'], this.services, () => <HomePage/>);
    specialPricesMarket = new RouteModel(['/special-prices-market'], this.services, () => <SpecialPricesMarketPage/>);


    private _routes: RouteModel[] | null = null
    get routes(): RouteModel[] {
        if(!this._routes) {
            this._routes = Object.keys(this)
                .map(propertyName => (this as any)[propertyName])
                .filter(route => route instanceof RouteModel);
        }

        return this._routes;
    }
}



